import Typography   from "@mui/material/Typography";
import Link         from "@mui/material/Link";
import {
    COPYRIGHT_EMAIL_TO,
    COPYRIGHT_EMAIL_US,
} from "config/config";

export default function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {COPYRIGHT_EMAIL_US}
            <Link color="inherit"href={`mailto:${COPYRIGHT_EMAIL_TO}`}> {COPYRIGHT_EMAIL_TO}</Link>
            <br/>
            {'©'}
            {new Date().getFullYear()} {' '}
            Funexpected LTD.
        </Typography>
  );
}